// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/locale.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message mlmbox.types.Locale
 */
export interface Locale {
    /**
     * @generated from protobuf field: string locale = 1;
     */
    locale: string;
    /**
     * @generated from protobuf field: string title = 2;
     */
    title: string;
}
/**
 * @generated from protobuf message mlmbox.types.Locale.Id
 */
export interface Locale_Id {
    /**
     * @generated from protobuf field: string locale = 1;
     */
    locale: string;
}
/**
 * @generated from protobuf message mlmbox.types.Locale.List
 */
export interface Locale_List {
    /**
     * @generated from protobuf field: repeated mlmbox.types.Locale items = 1;
     */
    items: Locale[];
}
// @generated message type with reflection information, may provide speed optimized methods
class Locale$Type extends MessageType<Locale> {
    constructor() {
        super("mlmbox.types.Locale", [
            { no: 1, name: "locale", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Locale>): Locale {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.locale = "";
        message.title = "";
        if (value !== undefined)
            reflectionMergePartial<Locale>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Locale): Locale {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string locale */ 1:
                    message.locale = reader.string();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Locale, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string locale = 1; */
        if (message.locale !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.locale);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Locale
 */
export const Locale = new Locale$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Locale_Id$Type extends MessageType<Locale_Id> {
    constructor() {
        super("mlmbox.types.Locale.Id", [
            { no: 1, name: "locale", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Locale_Id>): Locale_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.locale = "";
        if (value !== undefined)
            reflectionMergePartial<Locale_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Locale_Id): Locale_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string locale */ 1:
                    message.locale = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Locale_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string locale = 1; */
        if (message.locale !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.locale);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Locale.Id
 */
export const Locale_Id = new Locale_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Locale_List$Type extends MessageType<Locale_List> {
    constructor() {
        super("mlmbox.types.Locale.List", [
            { no: 1, name: "items", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => Locale }
        ]);
    }
    create(value?: PartialMessage<Locale_List>): Locale_List {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.items = [];
        if (value !== undefined)
            reflectionMergePartial<Locale_List>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Locale_List): Locale_List {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated mlmbox.types.Locale items */ 1:
                    message.items.push(Locale.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Locale_List, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated mlmbox.types.Locale items = 1; */
        for (let i = 0; i < message.items.length; i++)
            Locale.internalBinaryWrite(message.items[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.Locale.List
 */
export const Locale_List = new Locale_List$Type();
